export default function isEmptyObject(obj: any) {
  return obj && Object.keys(obj).length === 0;
}
